/**
 * This mixin is for use by Home widgets that are migrating from the phase 1 look to the phase 2
 * look. It should only include code to help in this migration.
 */
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('FeatureFlagsModule', {
      homePageV2Orange: state => state.betaFeatures.homePageV2Orange,
      homePageV2Blue: state => state.betaFeatures.homePageV2Blue,
    }),

    setActiveFFOrange() {
      return this.homePageV2Orange;
    },

    setActiveFFBlue() {
      return this.homePageV2Blue;
    },
  },
};
